import { RecordLabelState } from './state';

export const resetOnboarding = (): RecordLabelState['onboarding'] => ({
  started: false,
  name: '',
  artists: [],
});

export const recordLabelsInitialState: RecordLabelState = {
  loaded: false,
  list: [],
  artists: {},
  member: [],
  operators: {},
  onboarding: resetOnboarding(),
};
